<template>
  <div class="modal-holder">
    <Transition name="bounce">
      <div class="modal-content" v-if="showModalContent">
        <div class="modal-row">
          <div class="heading">
            <h5>
              Total Trip: <span>{{ totalNumberOfTrips }}</span>
            </h5>
            <i class="bi bi-x-circle" @click="$emit('closeModal')"></i>
          </div>
        </div>
        <div
          class="modal-row"
          v-for="(attendance, index) in trWiseAttendanceSummary"
          :key="index"
        >
          <div class="attendance-info">
            <h6>
              {{
                attendance.trip_code
                  ? attendance.trip_code
                  : 'Trip ID not found'
              }}
            </h6>
            <ul>
              <li>
                Total Trip: <b>{{ attendance.total }}</b>
              </li>
              <li>Present: {{ attendance.Present }}</li>
              <li>Absent: {{ attendance.Absent }}</li>
            </ul>
          </div>
        </div>
        <div class="modal-row">
          <div class="footer">
            <h6>Do you want to generate the Bill?</h6>
            <div class="buttons">
              <button class="btn btn-primary" @click="generateBill()">
                Yes
              </button>
              <button class="btn btn-link" @click="$emit('closeModal')">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  props: ['totalNumberOfTrips', 'trWiseAttendanceSummary', 'unlist'],
  data() {
    return {
      showModalContent: false
    };
  },
  methods: {
    generateBill() {
      this.$emit('closeModal');
      if (this.unlist) {
        this.$emit('unlistAttendances');
      } else {
        this.$emit('verifyAttendances');
      }
    }
  },
  mounted() {
    this.showModalContent = true;
  }
};
</script>

<style scoped>
.modal-holder {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(18, 18, 18, 0.6);
  top: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
}
.modal-content {
  background: #fff;
  width: 430px;
  padding: 0 20px;
  border-radius: 12px;
  max-height: 100%;
  overflow: auto;
}
.modal-row {
  padding: 16px 0;
  border-bottom: 0.5px solid #d5d5d5;
}
.modal-row:last-child {
  border-bottom: none;
}
h5,
h6,
ul {
  margin-bottom: 0;
}
.modal-row ul {
  padding-left: 0;
}
.modal-row ul li {
  list-style: none;
}

.heading h5 {
  font-size: 20px;
  font-weight: 500;
  float: left;
  line-height: 24.38px;
}
.heading h5 span {
  color: #a95eea;
}
.heading i {
  cursor: pointer;
  float: right;
  font-size: 20px;
  color: #949494;
  line-height: 24.38px;
}
.heading i:hover {
  color: red;
}
.attendance-info {
  padding: 16px 108px 16px 16px;
  background: #f4f0ff;
  border-radius: 6px;
}
.attendance-info h6 {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
}
.attendance-info ul li {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  margin-top: 8px;
}
.footer h6 {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}
.footer .buttons {
  float: right;
  margin-top: 16px;
}
.footer .buttons button {
  padding: 9px 24px;
}
.footer .buttons .btn-link {
  text-decoration: none;
  color: #652f8f;
}
.footer .buttons .btn-link:hover {
  color: #a95eea;
}
.bounce-enter-active {
  animation: bounce-in 0.4s;
}
.bounce-leave-active {
  animation: bounce-in 0.4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
